/**
 * 组件的emit事件
 */
export const emits = [
  /** 点击通知事件(suffix为go时) */
  'more',
  /** 点击操作按钮 */
  'operation',
  /** 点击关闭(suffix为close时)*/
  'close',
];
